import React, { useRef, useState } from "react";
import axios from "axios";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 22, color: "white" }} spin />
);

const ScanDoc = ({ memo, setMemo }) => {
  const [load, setLoad] = useState(false);
  const inputFileRef = useRef(null);
  const onFileChange = (e) => {
    setLoad(true);
    const formData = new FormData();
    formData.append("uploadfile", e.target.files[0]);
    axios
      .post("https://api.aiforthai.in.th/ocr", formData, {
        headers: {
          Apikey: "bXagwMODVlCkp1fxJm7jyZjwy22D81G5",
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        if (res.data.Spellcorrection.replace(/(\r\n|\n|\r)/gm, "").length > 0) {
          const data = res.data.Spellcorrection.split("\n");
          let theData = data
            .filter((e) => e !== "")
            .map((el) => {
              return `<p>${el}</p>`;
            });
          // if (memo[0].children[0].text === "") {
          //   setMemo(theData);
          // } else {
          //   setMemo([...memo, ...theData]);
          // }
          const theMemo = memo + theData.join("");
          setMemo(theMemo);
        }
        e.target.value = null;
        setTimeout(() => {
          setLoad(false);
        }, 500);
      })
      .catch((e) => {
        console.log(e);
        setTimeout(() => {
          setLoad(false);
        }, 500);
      });
  };
  const onBtnClick = () => {
    inputFileRef.current.click();
  };
  return (
    <form encType="multipart/form-data">
      <input
        type="file"
        accept=".png, .jpg, .jpeg"
        ref={inputFileRef}
        onChange={onFileChange}
        className="hidden"
      />
      <div
        onClick={() => {
          if (!load) {
            onBtnClick();
          }
        }}
        className="hover:bg-gray-600 m-0 mr-3 p-3 font-bold bg-gray-500 text-white rounded-md cursor-pointer w-12 flex justify-center items-center"
      >
        {load ? (
          <Spin indicator={antIcon} />
        ) : (
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5"
            />
          </svg>
        )}
      </div>
    </form>
  );
};

export default ScanDoc;
